export default class RichText {
	static init() {

		this.editorImages = document.querySelectorAll('.rich-text img');
		this.editorImages.forEach((img) => {
			let link = img.closest('a');
			if (link && link.getAttribute('target') !== "_blank") {
				link.classList.add('image-pswp');
				link.setAttribute('data-pswp-src', img.src);
				link.setAttribute('data-pswp-width', img.getAttribute('width'));
				link.setAttribute('data-pswp-height', img.getAttribute('height'));
				link.setAttribute('data-pswp-alt', img.getAttribute('alt'));
			}
		});

		this.editorNeon = document.querySelectorAll('.rich-text .text-neon');
		this.editorNeon.forEach((el) => {

			const parent = el.parentElement;
			parent.classList.add('has-neon');

			const text = el.innerHTML;
			el.innerHTML = `<span class='label'>${text}</span>`;
			for (let i = 0; i < 4; i++) {
				const span = document.createElement("span");
				span.innerHTML = text;
				span.classList.add('blur');
				el.appendChild(span);
			}

		});
	}
}